import * as React from "react";
import Content from "../../../Content";

import Axios from "../../Components/Axios";
import moment from "moment";

import DataTable from '../../../DataTable';
import {IMaskInput} from "react-imask";

class AbonentLogs extends React.Component{

    defaultPath = '/admin/abonent_logs/';

    getContentProviders() {
        Axios
            .get('api/kp/list')
            .then(r => this.setState({ contentProviders: r.data }))
            .catch(e => this.props.history.push('/'));
    }

    constructor(props) {
        super(props);
        let urlParams = new URLSearchParams(this.props.qs ?? '');

        this.state = {
            contentProviders: [],
            data: [],
            cp: urlParams.get('cp') ?? 0,
            periodFrom: urlParams.get('periodFrom') ?? moment().format("YYYY-MM-DD"),
            periodTo: urlParams.get('periodTo') ?? moment().format("YYYY-MM-DD"),
            periodType: "today",
            services: [],
            service: urlParams.get('service') ?? 0,
            msisdn: urlParams.get('msisdn') ?? '',
        };
    }

    async handleSubmit(e, self) {
        e.preventDefault();
        if(this.state.periodType === "today") {
            await this.setState({
                periodFrom: moment().format("YYYY-MM-DD"),
                periodTo: moment().format("YYYY-MM-DD")
            });
        }

        const searchParams = (
            new URLSearchParams({
                periodFrom: this.state.periodFrom,
                periodTo: this.state.periodTo,
                cp: this.state.cp,
                service: this.state.service,
                msisdn: this.state.msisdn
            })
        ).toString();

        this.props.history.push(this.defaultPath + searchParams);

    }

    getLog(params) {
        Axios
            .get('api/abonent_logs/list?' + (new URLSearchParams(params)).toString())
            .then(r => {
                const data = r.data.map(v => {
                    v.date = moment(v.dateadd.date).format('YYYY-MM-DD HH:mm:ss');
                    return v;
                });
                this.setState({ list: data });

                this.state.dataTable.update(r.data);

            })
            .catch(e => this.props.history.push('/'));

    }

    getServices() {
        Axios
            .get('api/services/list')
            .then(r => this.setState({ services: r.data }))
            .catch(e => this.props.history.push('/'));
    }

    componentDidMount() {
        this.setState({
            dataTable: DataTable.init({ columns: [
                'id','ip','sessionId','eventType','msisdn','titleRu','source','tethering','smsAuth','urlCode','lang','date',
            ], order: [ [ 0, 'desc' ] ] })
        });
        this.getContentProviders();
        this.getServices();
        this.loadData(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!!this.props.qs && this.props.qs !== prevProps.qs) {
            this.loadData(this);
        }
    }

    loadData(self) {
        const qs = this.props.match.params.params;
        const urlParams = new URLSearchParams(qs ?? '');

        const params = {
            cp: urlParams.get('cp') ?? 0,
            periodFrom: urlParams.get('periodFrom') ?? moment().format("YYYY-MM-DD"),
            periodTo: urlParams.get('periodTo') ?? moment().format("YYYY-MM-DD"),
            service: urlParams.get('service') ?? 0,
            msisdn: (urlParams.get('msisdn') ?? '').replace(/\D/g, '')
        }

        if(
            params.periodTo !== moment().format("YYYY-MM-DD") ||
            params.periodFrom !== moment().format("YYYY-MM-DD")
        ) {
            this.setState({
                periodType: 'interval',
                periodFrom: params.periodFrom,
                periodTo: params.periodTo
            });
        }

        self.getLog(params);
    }

    handleChange(e, element) {
        this.setState({[element]: e.target.value});
    }

    render() {
        return (
            <Content title = "Логи абонентов">
                <h4 className="mb-3">Логи абонентов</h4>
                <form className="form-inline" onSubmit={e => this.handleSubmit(e, this)}>
                    <div className="form-group   mb-2 ">
                        <label>
                            Контент-провайдер
                            <select className="form-control ml-2" value = {this.state.cp} onChange={e => this.handleChange(e, 'cp')} >
                                <option value="0">По всем КП</option>
                                {
                                    this.state.contentProviders.map(v => <option key={v.id} value={v.id}>{v.title}</option>)
                                }
                            </select>
                        </label>
                    </div>
                    <div className="form-group ml-4 mb-2 ">
                        <label>
                            Услуга
                            <select className="form-control ml-2" value = {this.state.service} onChange={e => this.handleChange(e, 'service')} >
                                <option value="0">По всем услугам</option>
                                {
                                    this.state.services.map(v => <option key={v.id} value={v.id}>{v.titleRu}</option>)
                                }
                            </select>
                        </label>
                    </div>

                    <div className="form-group ml-4  mb-2 ">
                        <label htmlFor="staticEmail2" className="sr-only">Период</label>
                        <select className="form-control" name="period" id="period" value={this.state.periodType} onChange={e => this.handleChange(e, 'periodType')}>
                            <option value="today"> За сегодня</option>
                            <option value="interval"> За период</option>
                        </select>
                    </div>
                    {
                        this.state.periodType === "interval" &&
                        <>
                            <div className="form-group  ml-sm-4  mb-2 periods">
                                <label htmlFor="staticEmail2">Дата с </label>
                                <input className="form-control date ml-2" type="date" value={this.state.periodFrom} onChange={e => this.handleChange(e, 'periodFrom')} />
                            </div>
                            <div className="form-group  ml-sm-4  mb-2 periods">
                                <label htmlFor="staticEmail2">до </label>
                                <input className="form-control date ml-2" type="date" value={this.state.periodTo} onChange={e => this.handleChange(e, 'periodTo')} />
                            </div>
                        </>
                    }

                    <div className="form-group  ml-sm-4  mb-2 periods">
                        <IMaskInput
                            mask={'{996}(000)00-00-00'}
                            type="tel"
                            className="form-control date ml-2"
                            placeholder="996(555)50-50-50"
                            value={this.state.msisdn}
                            onChange={e => this.handleChange(e, 'msisdn')}
                        />
                    </div>
                    <div className="form-group ml-sm-4 mb-2 mt-2">
                        <button type="submit" className="btn btn-primary mb-2">Показать отчет</button>
                    </div>
                </form>
                <div className="table-responsive">
                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                        <thead>
                            <tr>
                                <th>LOG_ID</th>
                                <th>IP</th>
                                <th>Сессия</th>
                                <th>Тип лога</th>
                                <th>Номер</th>
                                <th>Услуга</th>
                                <th>Источник</th>
                                <th>Тетеринг</th>
                                <th>SMS авторизация</th>
                                <th>URL код</th>
                                <th>Язык</th>
                                <th>Дата</th>
                            </tr>
                        </thead>
                        <tfoot>
                            <tr>
                                <th>LOG_ID</th>
                                <th>IP</th>
                                <th>Сессия</th>
                                <th>Тип лога</th>
                                <th>Номер</th>
                                <th>Услуга</th>
                                <th>Источник</th>
                                <th>Тетеринг</th>
                                <th>SMS авторизация</th>
                                <th>URL код</th>
                                <th>Язык</th>
                                <th>Дата</th>
                            </tr>
                        </tfoot>
                    </table>

                </div>
            </Content>
        );
    }
}

export default AbonentLogs;